<template>
	<v-container fluid class="ma-0 pa-0">
		<Header :areaLoading="areaLoading" @statusChange="statusChangeFunc"
			@clickGroupEdit="clickGroupEditFunc" />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
      <v-row class="ma-0 pa-0" v-if="search">
        <v-col class="ma-0 pa-0 mt-2 pb-1" cols="12" id="search_result">
          <v-row class="ma-0 pa-0 pr-8" justify="space-between" align="center">
            <v-col class="ma-0 pa-0" cols="auto">{{tc('filteringResult')}}</v-col>
            <v-col class="ma-0 pa-0" cols="auto">
              <v-btn id="back_clean_btn1" width="auto" height="auto" 
                class="back_clean_btn ma-0 pa-2 ml-3" 
								elevation="0" @click="deleteSearchResult()">
								<v-row class="ma-0 pa-0" align="center" style="color:white;">
									<v-img max-height="1.5rem" max-width="1.5rem" class="ma-0 pa-0 mr-2"
										src="@/assets/images/close_grey.png"></v-img>
                    {{tc('cancelSearch')}}
								</v-row>
							</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-0" justify="center">
        <v-col class="ma-0 pa-0 mt-10 mb-10" cols="10">
          <v-row class="ma-0 pa-0" style="margin-left: 3rem !important;">
            <v-col class="ma-0 pa-0 title_grey" cols="3">
              {{tc('cameraName')}}
            </v-col>
            <v-col class="ma-0 pa-0 title_grey" cols="2">
              {{tc('operationStartDate')}}
            </v-col>
            <v-col class="ma-0 pa-0 title_grey" cols="3">
              {{tc('uauSerial')}}
            </v-col>
            <v-col class="ma-0 pa-0 title_grey" cols="2">
              {{tc('portName')}}
            </v-col>
            <v-col class="ma-0 pa-0 title_grey" cols="2">
              {{tc('cameraStatus')}}
            </v-col>
          </v-row>
          <template v-if="areaLoading == false">
						<template v-if="storeArray.length > 0">
							<v-list id="status_list" class="test_list">
								<v-list-group sub-group color="black" class="detail_group"
									v-for="(item, index) in storeArray" :key="index" :ripple="false" :value="selectedStatus">
									<template v-slot:activator>
										<v-list-item-content>
											<v-row class="ma-0 pa-0">
												<v-col class="ma-0 pa-0" cols="12">
													{{item.customerName}}
												</v-col>
											</v-row>
										</v-list-item-content>
									</template>
									<v-list-item v-for="(detail, index_detail) in item.cameras" 
										:key="index_detail" class="ma-0 pa-0"
										@click="handleCameraClick(detail)">
										<v-list-item-content class="detail_list">
											<v-row class="ma-0 pa-0" align="center">
												<v-col class="ma-0 pa-0 pr-4" cols="3">
													<p style="white-space:pre-wrap; word-break:break-all; word-wrap:break-word;" class="ma-0">
														{{detail.cameraName | cameraNameLength}}
													</p>
												</v-col>
												<v-col class="ma-0 pa-0" cols="2">
													{{detail.createTime | dateFormat}}
												</v-col>
												<v-col class="ma-0 pa-0" cols="3">
													{{detail.serialCd}}
												</v-col>
												<v-col class="ma-0 pa-0" cols="2">
													{{detail.portName}}
												</v-col>
												<v-col class="ma-0 pa-0" cols="2" v-if="detail.isOnline">
													<v-col class="ma-0 pa-0">
														{{t('online')}}
													</v-col>
												</v-col>
												<v-col class="ma-0 pa-0" cols="2" v-else>
													<v-row class="ma-0 pa-0">
														<v-col class="ma-0 pa-0 status_off" cols="auto" style="align-self:center;">
															{{t('offline')}}
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-list-item-content>
									</v-list-item>
								</v-list-group>
							</v-list>
						</template>
						<template v-else>
							<v-col class="ma-0 pa-15" cols="12">
								{{t('noData')}}
							</v-col>
						</template>
          </template>
          <template v-else>
					<v-col class="ma-0 pa-2" cols="12" align="left">
						<v-skeleton-loader
							:boilerplate="false" elevation="0" dark 
							type="list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line"
						></v-skeleton-loader>
					</v-col>
				</template>
        </v-col>
      </v-row>

      <GroupEditDialog :dialogVisible="groupEditDialogVisible" :fromHeader="false" 
				:fromNoti="false" :cameraStatusStoreList="currentSelectedData"
        @visible="groupEditDialogVisibleFunc" @selectedStores="selectedStoresFunc" />
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from './Header.vue';
import GroupEditDialog from '@/components/dialogs/GroupEditDialog.vue';
export default {
	components: {
		Header, GroupEditDialog
	},
	mixins: [mixin.common],
	data: () => ({
    storeName: '',
    groupEditDialogVisible: false,
    selectedStatus: 0,
    storeArray: [],
    areaLoading: false,
    tempData: [],
		currentSelectedData: [],
    search: false,
		isMaintenance: false,
	}),
  filters: {
    dateFormat: function(str) {
			if(str != undefined) return str.length > 10 ? str.substring(0,10) : str;
			else return '';
		},
    cameraNameLength: function(str) {
      if(str != undefined) {
				if(str.length < 51) {
					return str;
				} if(str.length > 50) {
					return str.substring(0, 50) + '...';
				}
			} else {
				return '';
			}
    },
		statusFormat: function(str) {
			if(str != undefined) {
				return str.length > 20 ? str.substring(0,20) + '...' : str;
			} else {
				return '';
			}
		},
  },
  watch: {
    selectedStatus: function(item) {
			console.log(this.tempData);
			this.checkSelectedCameraStatus(this.tempData);
    }
  },
  mounted() {
		this.isMaintenance = this.maintenanceCheck(this.$store.getters.getRole);
    this.fetchData();
  },
  methods: {
    tc(t) {
      return this.$t("lang.cameraStatus." + t);
    },
    deleteSearchResult() {
      this.search = false;
      this.fetchData();
    },
    groupEditDialogVisibleFunc(visible) {
      this.groupEditDialogVisible = visible;
			if(visible) {
				this.currentSelectedData = JSON.parse(JSON.stringify(this.tempData));
			}
    },
		fetchData() {
			this.areaLoading = true;
			let params = {};

			this.networkController.getCameraStatus(params)
				.then(async (res) => {
					console.log('%cCamera Status\n', "color:#008DD0;", res.data);
					let tempArray = this.processCameraData(res.data);
					let sortedArray = this.sortStoresByCustomerName(tempArray);

					this.checkSelectedCameraStatus(sortedArray);
					this.tempData = sortedArray;
					this.$store.commit('setCameraStatusData', this.tempData);
					this.currentSelectedData = JSON.parse(JSON.stringify(this.tempData));
					this.areaLoading = false;
				})
				.catch(error => {
					this.areaLoading = false;
				});
		},
		// 각 아이템의 카메라 이름을 정규화하고 정렬합니다.
		processCameraData(data) {
			data.forEach((item) => {
				if (item.cameras.length > 0) {
					item.cameras.forEach(camera => {
						camera.normalizedName = this.normalizeCameraName(camera.cameraName);
					});
					item.cameras.sort(this.compareCameras);
				}
			});
			return data;
		},
		// 카메라 이름을 정규화하며, null 또는 빈 이름을 적절히 처리합니다.
		normalizeCameraName(name) {
			return name ? name.normalize('NFKC') : '';
		},
		// 두 카메라를 정규화된 이름을 기준으로 비교합니다.
		compareCameras(a, b) {
			if (a.normalizedName === b.normalizedName) return 0;
			if (a.normalizedName === '') return 1; // null 또는 빈 이름을 가장 낮은 값으로 처리
			if (b.normalizedName === '') return -1; // null 또는 빈 이름을 가장 낮은 값으로 처리
			return (a.normalizedName < b.normalizedName) ? -1 : 1;
		},
		// 고객 이름을 정규화하고 상점 아이템을 정렬합니다.
		sortStoresByCustomerName(data) {
			data.forEach(item => {
				item.normalizedCustomerName = item.customerName.normalize('NFKC');
			});
			return data.sort(this.compareStores);
		},
		// 두 상점 아이템을 정규화된 고객 이름을 기준으로 비교합니다.
		compareStores(a, b) {
			return (a.normalizedCustomerName < b.normalizedCustomerName) ? -1 : (a.normalizedCustomerName > b.normalizedCustomerName) ? 1 : 0;
		},
		makeOriginalData(selectedStores) {
			// 매장편집으로 추가한 매장데이터에는 카메라데이터가 없음
			// 처음 fetchData로 가져온 데이터에서 카메라데이터를 넣어줘야 한다
			return new Promise((resolve, reject) => {
				const originalArray = this.$store.getters.getCameraStatusData;
				let result = [];
				originalArray.forEach(original => {
					let filterResult = selectedStores.filter((value) => {
						return value.unisCustomerCd == original.unisCustomerCd
					})
					result.push(...filterResult);
				})
				return resolve(result);
			});
		},
		checkSelectedCameraStatus(storeData) {
			// 카메라 온라인, 오프라인 상태 확인해서 데이터 정렬
			if(this.selectedStatus == 0) { // 모든 카메라
				this.storeArray = storeData;
			} else { // 1 오프라인만
				let temp = JSON.parse(JSON.stringify(storeData));
        let temp2 = JSON.parse(JSON.stringify(storeData));
        temp.forEach((store, storeIndex) => {
          let filterResult = store.cameras.filter((value) => {
						return value.isOnline == false
					})
					temp2[storeIndex].cameras = filterResult;
        })
        this.storeArray = temp2;
			}
		},
    async selectedStoresFunc(stores) {
			const result = await this.makeOriginalData(stores);
			console.log(result);
			this.tempData = JSON.parse(JSON.stringify(result));
			this.currentSelectedData = JSON.parse(JSON.stringify(result));
      this.search = true;
			this.checkSelectedCameraStatus(result);
    },
		statusChangeFunc(status) {
      console.log('status', status)
			this.selectedStatus = status;
		},
		clickGroupEditFunc(value) {
			this.groupEditDialogVisible = value;
		},
		handleCameraClick(detail) {
			if (detail.isUas && this.isMaintenance && detail.uasThresholdSupport) {
				this.pushRouteObject('/camera-status/maintenance', { detail });
			}
		}
  }
}
</script>

<style lang="scss" scoped>
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
  .v-list-item--active .v-list-item__content {
    color: white;
  }
  .v-list-item__icon.v-list-group__header__prepend-icon {
    color: white;
  }
  .slider_slot {
    align-items: center;
    height: 2.5em;
    .v-input__prepend-outer, .v-input__append-outer{
      margin-right: 0px;
      width: 7.5em;
      color: white;
    }
  }
  .v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
  .detail_group {
    .v-list-item {
      padding: 0px;
      i {
        color: white;
      }
      .v-list-item__icon {
        .v-icon {
          transform: rotate(-0.5turn);
        }
      }
    }
    .v-list-item--active {
      .v-list-item__icon {
        .v-icon {
          transform: rotate(0turn);
        }
      }
    }
  }
  // v-skeleton-loader css 설정
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-two-line {
		background: #222222 !important;
	}
  // Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
.status_select {
  font-size: 0.8em;
}
.title_grey {
  text-align: left;
  font-size: 0.8em;
  color: #8E8E8E;
}
.total_store {
  text-align: left;
  border-bottom: 1px solid #333740;
  height: 3em;
  line-height: 3em;
}
#status_list {
  background: transparent;
  border: none;
  padding-top: 0px;
}
#search_result {
  border-bottom: 1px solid #333740;
}
.detail_group {
text-align: left;
  // border-bottom: 1px solid #333740;
}
.detail_group::after{
  border-bottom: 1px solid #333740;
  content: '';
  display: block;
  width: 97%;
  margin-left: auto
}
.detail_list{
  margin-left: 3rem !important;
  border-top: 1px solid #333740;
  padding-top: 14px;
}
.status_off{
  color: red;
}
.back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem !important;
	color: white;
}
</style>